export default "__VITE_ASSET__34$8UcEu__"